module.exports = __webpack_public_path__ + "static/media/imgs_200.77b2bdfe.jpg";